<template>
  <div>
    <!-- {{ filteredLenses }} -->

    <v-card flat class="titlebar">
      <v-card-text
        class="d-flex flex-column align-start py-2"
        style="width: 100%"
      >
        <div
          class="d-flex flex-sm-row flex-column flex-wrap align-sm-center mx-4"
          style="width: 95%"
        >
          <slot name="headerTitle">
            <div v-if="nameSearch" class="d-flex flex-row align-center">
              <v-img
                v-if="$vuetify.breakpoint.smAndUp"
                src="https://www.eyedock.com/images/pathologies/search.svg"
                class="mr-4"
              ></v-img>
              <div>
                <div class="title">Lenses Matching</div>
                <div>
                  &quot;<i>{{ nameSearch | truncate(50) }}</i
                  >&quot;
                </div>
              </div>
            </div>

            <div v-else-if="oneCompanyID" class="companyTitle">
              <!-- <div class="caption ml-6">Lenses by</div> -->
              <product-image
                type="companyId"
                :companyId="oneCompanyID"
                :maxHeight="60"
                :maxWidth="300"
                position="left center"
                :eager="true"
                :placeholder="oneCompanyName"
              />
            </div>
            <div v-else-if="oneTypeKey" class="companyTitle">
              <!-- <div class="caption ml-6">Lenses by</div> -->
              <soft-type-icon
                type="type"
                :lens="{ type_tag: oneTypeKey }"
                :width="35"
                :showLabel="true"
                class=""
              />
            </div>

            <div v-else class="text-h3">Search Results</div>
          </slot>
          <v-spacer class="d-none d-sm-flex"></v-spacer>

          <!-- <div class="d-flex flex-column py-1"> -->
          <div class="displayOptions d-flex flex-rwo flex-wrap mb-sm-2">
            <!-- <span class="overline">Display Options</span> -->
            <!-- {{ viewType }} -->
            <div class="d-none d-sm-block pl-4 pb-2 mr-3">
              <v-btn-toggle
                v-model="viewType"
                rounded
                active-class="activeToggle"
              >
                <v-btn x-small @change="loading = true" :value="0"
                  ><v-icon x-small>mdi-view-grid-outline</v-icon>
                  <span class="d-none d-md-block">Cards</span></v-btn
                >
                <v-btn x-small @change="loading = true" :value="1"
                  ><v-icon x-small>mdi-format-list-bulleted</v-icon>
                  <span class="d-none d-md-block">List</span></v-btn
                >
              </v-btn-toggle>
            </div>
            <v-checkbox
              v-if="paramCounts.companies > 1"
              v-model="groupByCompany"
              label="Group by company"
              dense
              hide-details="auto"
              class="pa-0 my-2 my-sm-0 mx-1"
            ></v-checkbox>
            <v-checkbox
              v-if="paramCounts.types > 1"
              v-model="groupByType"
              label="Group by type"
              dense
              hide-details="auto"
              class="pa-0 my-2 my-sm-0 mx-1"
            ></v-checkbox>
            <v-checkbox
              v-model="showAnnualPrices"
              label="Show Prices"
              dense
              hide-details="auto"
              class="pa-0 my-2 my-sm-0 mx-1"
            ></v-checkbox>
          </div>
          <!-- </div> -->
        </div>
        <!-- todo - put these filters (and the ones in softPowerResultsTable) in their own component -->

        <div
          class="d-flex flex-column flex-sm-row flex-wrap align-sm-center ml-0 ml-6 mt-2"
          style="width: 100%"
        >
          <slot name="headerContent">
            <div style="max-width: 300px ma-0 pa-0">
              <v-text-field
                clearable
                dense
                v-model="filters.name"
                label="Filter by name"
                hide-details="auto"
                class="compact-select mr-1 pt-0 mt-0"
                v-if="lensCount > 3"
              ></v-text-field>
            </div>
            <v-checkbox
              class="mt-3 mb-3 mt-sm-1 mb-sm-1 mr-4"
              v-model="filters.high_dk"
              label="Only high dk"
              hide-details="auto"
              dense
              v-if="lensCount > 3"
            ></v-checkbox>
            <replace-select
              @replace="setFilterValue('replace', $event)"
              :external="filters.replace"
              class="mr-3 pt-3 pt-sm-0"
              :options="replaceOptionsForSet"
              v-if="lensCount > 3"
              style="margin-top: 2px"
            ></replace-select>
          </slot>
        </div>
      </v-card-text>
    </v-card>

    <div
      v-if="filteredLenses && filteredLenses.length && !advancedSearch"
      class="d-flex flex-row caption flex-wrap my-2 mx-2"
    >
      <!-- <v-spacer></v-spacer> -->
      <!-- <div class="my-2 d-flex flex-row flex-wrap"> -->
      <div v-if="filterSummary">
        Filtering for <span v-html="filterSummary"></span>
        <span v-if="filterCount"> ({{ filterCount }} lenses hidden)</span>
      </div>

      <!-- <div v-else>No filters applied</div> -->
      <v-spacer></v-spacer>
      <v-btn
        rounded
        outlined
        x-small
        @click="doExpand = !doExpand"
        color="primary"
        v-if="groupByCompany"
      >
        {{ doExpand ? "Collapse All" : "Expand All" }}
        <v-icon x-small class="ml-1"
          >{{ doExpand ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}
        </v-icon>
      </v-btn>
      <!-- </div> -->
    </div>

    <v-alert
      v-if="filteredLenses && !filteredLenses.length"
      class="my-6 mx-0 mx-sm-6"
      :border="'left'"
      color="orange lighten-3"
      colored-border
      type="warning"
    >
      There are no lenses matching your search and filter settings.
    </v-alert>

    <div v-if="filteredLenses && filteredLenses.length && !showCards">
      <soft-cl-table
        :items="filteredLenses"
        :groupBy="groupBy"
        :doExpand="doExpand"
        :oneCompany="oneCompanyID"
        :showAnnualPrices="showAnnualPrices"
        @lensSelected="handleClick($event)"
        class="mt-2"
        @loaded="loading = false"
      ></soft-cl-table>
    </div>
    <div v-if="filteredLensesIds && showCards">
      <soft-cl-cards
        :itemIds="filteredLensesIds"
        :lensObj="lensObj"
        :groupBy="groupBy"
        :doExpand="doExpand"
        :showAnnualPrices="showAnnualPrices"
        @loaded="loading = false"
      ></soft-cl-cards>
      <v-fade-transition>
        <loading
          v-if="loading"
          message="Looking through the fitting sets . . . "
        ></loading>
      </v-fade-transition>
    </div>

    <!-- {{ filteredLensesByCompany }} -->
    <div v-for="(lensGroup, index) in null" :key="index">
      <v-card v-if="lensGroup.lenses" class="mt-2 mb-8">
        <v-card-text>
          <div class="d-flex flex-column px-4 justify-center">
            <div class="  " v-if="!groupBy">
              <product-image
                v-if="paramCounts.company == 1"
                type="companyId"
                :companyId="parseInt(lensGroup.companyId)"
                :maxHeight="30"
                :maxWidth="200"
                position="center center"
                :eager="true"
                class="companyHeaderLogo"
                :placeholder="oneCompanyName"
              />
            </div>
            <div
              v-else
              class="text-h5 d-flex flex-row align-center companyHeaderLogo"
            >
              <div style="min-width: 40px" class="mr-4">
                <soft-type-icon
                  type="type"
                  :lens="lensGroup.lenses[0]"
                  :width="36"
                ></soft-type-icon>
              </div>
              {{ lensGroup.title }}
            </div>
          </div>

          <soft-cl-table
            v-if="!showCards"
            :items="lensGroup.lenses"
            @lensSelected="handleClick($event)"
          ></soft-cl-table>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import RxMethods from "@/assets/js/cls/RxMethods";
import ClCompanyMixin from "@/assets/js/cls/ClCompanyMixin";
import FilterDictionary from "@/assets/js/cls/FilterDictionary";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";

export default {
  name: "SoftResultDisplay",
  mixins: [RxMethods, ClCompanyMixin, FiltersMixin],
  components: {
    ProductImage: () => import("@/components/clStuff/ProductImage"),
    SoftTypeIcon: () => import("@/components/clStuff/SoftTypeIcon"),
    SoftClTable: () => import("@/components/clStuff/SoftClTable"),
    ReplaceSelect: () => import("@/components/clStuff/ReplaceSelect"),
    SoftClCards: () => import("@/components/clStuff/SoftClCards"),
    Loading: () => import("@/components/universalStuff/Loading"),
  },
  props: {
    lensObj: null,
    nameSearch: null,
  },
  data: function () {
    return {
      search: "",
      viewType: 1, // 0 is cards, 1 is list
      filters: { ...FilterDictionary.filterDefaults },
      filterDefaults: { ...FilterDictionary.filterDefaults },
      // groupBy: null, // null, company, or type
      groupByCompany: null,
      groupByType: null,
      showAnnualPrices: true,
      doExpand: true,
      loading: true,
      advancedSearch: null, // when true will not display filters
      hash: null, // store any hash that's passes in
      // filters: { replace: null, type: null, companyIds: [], name: "" },
    };
  },

  methods: {
    price(price) {
      return price ? "$" + price : "?";
    },

    powerRange(plus, minus) {
      let plusTxt = plus ? this.numToDiopterString(plus, 1) : "";
      let minusTxt = minus ? minus : "";
      let joiner = minusTxt ? " to " : "";
      return plusTxt + joiner + minusTxt;
    },
    handleClick(value) {
      //console.log(value);
      //this.$router.push({ path: `/lens/${value.id}` });
      let hash = this.hash ? "#" + this.hash : "";
      this.$router.push({ path: `/cls/details/${value.slug}${hash}` });
    },
  },
  computed: {
    lensCount: function () {
      let lenses = this.lensObj?.lenses;
      if (!lenses) return 0;
      return Object.keys(lenses).length;
    },
    filteredLensesIds: function () {
      if (!this.filteredLenses) return null;
      return this.filteredLenses.map(function (obj) {
        return obj.id;
      });
    },
    lensParamList: function () {
      let lenses = this.lensObj?.lenses;
      if (!lenses) return { companies: [], types: [], replaces: [] };
      let companies = [];
      let types = [];
      let replaces = [];
      //console.log(lenses);

      Object.values(lenses).forEach((lens) => {
        //let lens = lenses[key];
        //console.log(lens);
        let company_id = lens.company_id;
        let replace = lens.replace;
        let type_tag = lens.type_tag;
        if (!companies.includes(company_id)) companies.push(company_id);
        if (!replaces.includes(replace)) replaces.push(replace);
        if (!types.includes(type_tag)) types.push(type_tag);
      });
      return { companies: companies, types: types, replaces: replaces };
    },
    paramCounts: function () {
      let rtn = { companies: null, types: null, replaces: null };
      if (this.lensParamList) {
        rtn.companies = this.lensParamList.companies.length;
        rtn.types = this.lensParamList.types.length;
        rtn.replaces = this.lensParamList.replaces.length;
      }
      return rtn;
    },
    firstLensObj: function () {
      if (!this.lensObj?.lenses) return null;
      let firstCompanyKey = Object.keys(this.lensObj.lenses)[0];
      return this.lensObj.lenses[firstCompanyKey];
    },
    oneCompanyID: function () {
      if (!this.firstLensObj) return null;
      if (this.paramCounts.companies > 1) return null;
      return parseInt(this.firstLensObj.company_id);
    },
    oneCompanyName: function () {
      if (!this.firstLensObj) return null;
      if (this.paramCounts.companies > 1) return null;
      return this.firstLensObj.company;
    },
    oneTypeKey: function () {
      if (!this.firstLensObj) return null;
      if (this.paramCounts.types > 1) return null;
      return this.firstLensObj.type_tag;
    },

    showCards: function () {
      return this.viewType == 0;
    },

    groupBy: function () {
      let rtn = null;
      if (this.groupByCompany && this.paramCounts.companies > 1)
        rtn = "companyOrder";
      if (this.groupByType && this.paramCounts.types > 1) rtn = "typeOrder";
      return rtn;
    },

    filterSummary: function () {
      if (this.advancedSearch) return null;
      let rtn = [];
      let f = this.filters;
      let replace = FilterDictionary.titleForOptionKey("replace", f.replace);
      // let type = FilterDictionary.titleForOptionKey("type", this.oneTypeKey);
      if (replace) rtn.push(`<i>${replace.toLowerCase()}</i>`);
      // if (type) rtn.push(` <i>${type.toLowerCase()}</i>`);
      if (f.name) rtn.push(` <i>name includes '${f.name}'</i>`);
      if (f.high_dk) rtn.push("<i>high Dk lenses</i>");
      if (!rtn.length) return null;
      // rtn += " lenses";
      return rtn.join(", ");
    },

    filteredLenses: function () {
      // console.log("filteredLenses");
      let lenses = this.lensObj?.lenses;
      if (!lenses) return null;
      let filter = this.filters;
      let replaceFilter = FilterDictionary.daysArrayForReplacementKey(
        filter.replace
      );
      // let compArr = FilterDictionary.arrayForCompanyFilter(filter.company);
      let filteredLenses = [];
      Object.keys(lenses).forEach((lensId) => {
        let include = true;
        const item = lenses[lensId];

        if (filter.name && filter.name != "") {
          let nameMatch =
            item.name.toLowerCase().indexOf(filter.name.toLowerCase()) != -1;
          let companyMatch =
            item.company.toLowerCase().indexOf(filter.name.toLowerCase()) != -1;
          include = nameMatch || companyMatch;
        }

        if (filter.high_dk && parseFloat(item.dk) < 45) return false;

        // check for replacement match
        let lensDays = parseInt(item.replace);
        if (Array.isArray(replaceFilter) && replaceFilter.length > 0) {
          let replaceMatch = replaceFilter.includes(lensDays);
          include = include && replaceMatch; // && companyIdMatch;
        }
        if (include) filteredLenses.push(item);
      });

      return filteredLenses;
    },
    filterCount: function () {
      if (!this.filteredLenses) return null;
      return (
        Object.keys(this.lensObj.lenses).length - this.filteredLenses.length
      );
    },
    replaceOptionsForSet: function () {
      if (!this.lensObj.meta) return null;
      return this.lensObj.meta.replacements;
    },
  },
  watch: {
    // make a mixin to do this stuff
    groupByCompany(val) {
      localStorage.setItem("groupLensesByCompany", val);
      if (val) this.groupByType = false;
    },
    groupByType(val) {
      localStorage.setItem("groupLensesByType", val);
      if (val) this.groupByCompany = false;
    },
    showAnnualPrices(val) {
      localStorage.setItem("showAnnualPrices", val);
    },
  },
  mounted: function () {
    // console.log("softresultsdisplay mounted");
    // console.log("advancedSearch", this.advancedSearch);
    if (!this.advancedSearch) this.setFiltersFromHash();
    if (localStorage.getItem("groupLensesByCompany"))
      this.groupByCompany =
        localStorage.getItem("groupLensesByCompany") == "true";
    // this.setFiltersFromHash();
    if (localStorage.getItem("groupLensesByType"))
      this.groupByType = localStorage.getItem("groupLensesByType") == "true";
    if (localStorage.getItem("showAnnualPrices"))
      this.showAnnualPrices =
        localStorage.getItem("showAnnualPrices") == "true";
    let hash = window.location.hash.substring(1);
    if (hash) this.hash = hash;
  },
};
</script>

<style>
/* .companyHeaderLogo {
  width: 220px;
  height: 45px;
} */
.smallCompLogoDiv {
  width: 130px;
  height: 20px;
  padding: 6px 0;
}
.companyTitle {
  min-width: 325px;
}
.titlebar {
  border: 1px solid #cedae3 !important;
  background-image: linear-gradient(136deg, #fff 40%, #e3f2fd);
}
.compact-select {
  transform: scale(0.875);
  transform-origin: left;
}

/* .tubular {
  border-radius: 40px !important;
} */
</style>
